export const SELECTED_MENU = "SELECTED_MENU";
export const FOOD_CART = "FOOD_CART";
export const INCREMENT_ITEM = "INCREMENT_ITEM";
export const DECREMENT_ITEM = "DECREMENT_ITEM";
